<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class TrainStationsSearchMixin extends Vue {
        async searchTrainStations(rq) {
            const defaults = {
                pattern: null,
                limit: 0,
                productType: 'TRANSFER',
            }
            const rs = await this.$api.trainStations.get({...defaults, ...rq}, this.cancelTokenSource.token)
            //TODO trainStation.countryName is empty

            return rs
                .filter(trainStation => Object.prototype.hasOwnProperty.call(trainStation, 'name'))
                .map(trainStation => {
                    return Object.assign(trainStation, {type: 'trainStation', parentName: trainStation.countryName})
                })
        }
    }

    export default TrainStationsSearchMixin
</script>
